import React from 'react';
import {Link} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {bool, func, object} from 'prop-types';
import {Button, Grid, Header, Container} from 'semantic-ui-react';
import PrizeSitesDropdown from 'components/prizes/PrizeSitesDropdown';
import {isSponsored} from 'pages/EditPrize/utils';

const PrizeSummary = props => {
  const prizeType = isSponsored(props.prize) ? 'sponsored' : 'editorial';
  const unusedDrawDateField = props.prize.weeklyWinners ? 'winnerSelectionDate' : 'drawInfo';

  return (
    <Grid className='animResponse fadeInDown db-prize-summary'>
      <Grid.Row>
        <Grid.Column width={10} textAlign='left'>
          <Header as='h1'>
            <FormattedMessage id={`editprize.summary.heading.${prizeType}`} />
          </Header>
          <Link to={`/prizes/${prizeType}`}>
            <FormattedMessage id='editprize.summary.link.dashboard' />
          </Link>
        </Grid.Column>
        {props.userCanPublish ? (
          <React.Fragment>
            <Grid.Column width={3}><PrizeSitesDropdown /></Grid.Column>
            <Grid.Column width={3} textAlign='right'>
              <Button className='publish-prize-button' onClick={props.publishPrize}>
                <FormattedMessage id='buttons.publish' />
              </Button>
            </Grid.Column>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Grid.Column width={3}>{/* filler */}</Grid.Column>
            <Grid.Column width={3}><PrizeSitesDropdown /></Grid.Column>
          </React.Fragment>
        )}
      </Grid.Row>
    </Grid>
  );
};

PrizeSummary.propTypes = {
  prize: object.isRequired,
  userCanPublish: bool.isRequired,
  publishPrize: func.isRequired
};

export default PrizeSummary;



// WEBPACK FOOTER //
// ./public/components/prizes/PrizeSummary.jsx